import { createFileRoute, redirect } from '@tanstack/react-router';
import { requireAuth } from '../require-auth';
import { menuSearchSchema, menuSectionPath } from '../menu-search';

/**
 * Legacy entry point. Every Master Menu section is now its own page, so this
 * route only redirects: `?section=` picks the page (defaulting to branches)
 * and every other filter rides along untouched.
 */
export const Route = createFileRoute('/eats/menu')({
  // Auth guard — see `require-auth.ts`.
  beforeLoad: (ctx) => {
    requireAuth();
    const { section, ...rest } = ctx.search;
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: menuSectionPath(section),
      search: rest,
      replace: true,
    });
  },
  validateSearch: menuSearchSchema,
});
